<app-simple-dialog
  [title]="'exit-signing.modal.title' | translate"
  [analyticsPrefix]="'exit-signing-dialog'"
  #exitDialog
>
  <p class="nova-dialog__text" dialog-content>
    {{ "exit-signing.modal.message" | translate }}
  </p>

  <ng-container dialog-actions>
    <button
      novaButton
      variant="secondary"
      size="large"
      data-testid="exit-signing-cancel-button"
      appTrackedButton
      trackId="exit-signing-dialog:cancel"
      trackType="back"
      (click)="close()"
      class="cancel-button"
    >
      {{ "exit-signing.modal.cancel" | translate }}
    </button>
    <button
      novaButton
      variant="primary"
      size="large"
      data-testid="exit-signing-confirm-button"
      appTrackedButton
      trackId="exit-signing-dialog:exit"
      trackType="continue"
      (click)="confirmExit()"
      class="confirm-button"
    >
      {{ "exit-signing.modal.confirm" | translate }}
    </button>
  </ng-container>
</app-simple-dialog>
